<template>
  <div>
    <Breadcrumbs :items="items" />
    <ValidationObserver ref="observer">
      <v-sheet class="transparent-background-color pa-4">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{
                  $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                    $t("stockOutOrders.ObjectName"),
                  ])
                }}
                <v-chip
                  v-if="stock_outs.cancel_flg"
                  small
                  label
                  outlined
                  class="ms-4 mt-1"
                  color="danger"
                >
                  {{ $t("CRUD.cancelled") }}
                </v-chip>
                <span v-if="!isNew">
                  <v-chip
                    v-if="
                      stock_outs.type == 13 && stock_outs.actions.out_re_push
                    "
                    small
                    label
                    class="ms-4 mt-1"
                    color="danger"
                    text-color="white"
                  >
                    {{ $t("stockOutOrders.status.pushError") }}
                  </v-chip>
                  <v-chip
                    v-else
                    small
                    label
                    class="ms-4 mt-1"
                    :color="stock_outs.status | stockOrderOUTStatusColor"
                    :text-color="
                      stock_outs.status | stockOrderOUTStatusTextColor
                    "
                  >
                    {{ stock_outs.status | stockOrderOUTStatusText }}
                  </v-chip>
                </span>
                <v-spacer />
                <StockOrderOUTActions
                  v-if="isView"
                  :stock_out="stock_outs"
                  @stockOut="mode = 'out'"
                  @edit="mode = 'edit'"
                  :showEdit="stock_outs.actions && stock_outs.actions.out_edit"
                  :showComplete="
                    stock_outs.actions && stock_outs.actions.out_complete
                  "
                  :showCancel="
                    stock_outs.actions && stock_outs.actions.out_cancel
                  "
                  :showRePush="
                    stock_outs.actions && stock_outs.actions.out_re_push
                  "
                  detail-mode
                />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <!-- 提交 -->
                  <!-- <span v-if="stock_outs.type == 13">
                    <v-btn
                      v-if="preview"
                      small
                      dark
                      outlined
                      color="secondary"
                      class="px-2 me-2 mb-1 elevation-1"
                      @click.stop="preview = false"
                    >
                      <v-icon x-small class="pe-1">fa-times</v-icon>
                      {{ $t("CRUD.backForModify") }}
                    </v-btn>
                    <v-btn
                      v-if="
                        isNew &&
                        $permission.permissionAllow('StockOutOrders', 'add')
                      "
                      small
                      dark
                      color="primary"
                      class="px-2 me-2 mb-1"
                      @click.stop="preview ? doReturn() : doPreview()"
                    >
                      <v-icon x-small class="pe-1">fa-save</v-icon>
                      {{ $t("stockOutOrders.actions.returnSubmit") }}
                    </v-btn>
                  </span> -->
                  <span>
                    <v-btn
                      v-if="
                        isNew &&
                        $permission.permissionAllow('StockOutOrders', 'add')
                      "
                      small
                      dark
                      color="primary"
                      class="px-2 me-2 mb-1"
                      @click.stop="doSubmit()"
                    >
                      <v-icon x-small class="pe-1">fa-save</v-icon>
                      {{ $t("stockOutOrders.actions.submitStockOut") }}
                    </v-btn>
                  </span>
                  <!-- 编辑 -->
                  <v-btn
                    v-if="
                      stock_outs.actions &&
                      stock_outs.actions.in_edit &&
                      isEdit &&
                      $permission.permissionAllow('StockOutOrders', 'edit')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit('edit')"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("stockOutOrders.actions.editStockOUTSubmit") }}
                  </v-btn>
                  <!-- 出库 -->
                  <v-btn
                    v-if="
                      stock_outs.actions &&
                      stock_outs.actions.out_complete &&
                      isStockOut &&
                      $permission.permissionAllow('StockOutOrders', 'out')
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit('out')"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{
                      mode == "out"
                        ? $t("stockOutOrders.actions.confirmStockOut")
                        : $t("stockOutOrders.actions.stockOut")
                    }}
                  </v-btn>
                  <!-- 部分出库 -->
                  <!-- <v-btn
                  v-if="isStockOut"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit('part_out')"
                >
                  {{ $t("stockOutOrders.actions.stockPartOut") }}
                </v-btn> -->
                  <v-btn
                    v-if="
                      isView &&
                      $permission.permissionAllow(
                        'StockOutOrders',
                        'detailExport'
                      )
                    "
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="exportDetail()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("stockOutOrders.Fields.export") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 出库单编号 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.stock_out_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.stock_order_code }}
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("stockOutOrders.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 创建时间 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.created | formatTime }}
                  </v-card>
                </v-col>

                <!-- 出库类型 -->
                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                    v-if="isNew"
                  >
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.stock_out_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-select
                      v-if="isNew && !preview"
                      v-model="stock_outs.type"
                      :items="
                        $consts.stock_out_order.types.filter(
                          (element) =>
                            element.value == 1 ||
                            element.value == 2 ||
                            element.value == 12 ||
                            element.value == 11 ||
                            element.value == 13 ||
                            element.value == 14
                        )
                      "
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      @change="stock_out_details = []"
                    >
                    </v-select>
                    <span v-else>
                      {{ stock_outs.type | stockOrderOUTTypesText }}
                    </span>
                  </v-card>
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile v-else>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.stock_order_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_outs.out_type_str }}</span>
                  </v-card>
                </v-col>
                <!-- 原订单号 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="stock_outs && stock_outs.type == 13"
                >
                  <v-card
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                    v-if="isNew"
                  >
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.for_order_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ forOrder ? forOrder.order_code : "" }}
                    <v-btn
                      v-if="isNew && !preview"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      :disabled="returnMaterialsLoading"
                      @click.stop="selectOrderDialog = true"
                    >
                      <v-icon x-small class="pe-1">fa-store</v-icon>
                      {{ $t("CRUD.rechooseInfo", [$t("Order.title")]) }}
                    </v-btn>
                    <v-btn
                      v-if="forOrderFlg && !preview"
                      fab
                      icon
                      x-small
                      text
                      @click.stop="forOrderFlg = false"
                    >
                      <v-icon x-small class="pe-1">fa-times</v-icon>
                    </v-btn>
                  </v-card>
                  <v-card class="pa-2 text-no-wrap" outlined tile v-else>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.for_order_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_outs.for_order_code
                        ? stock_outs.for_order_code
                        : ""
                    }}
                  </v-card>
                </v-col>
                <!-- 退货单号 -->
                <v-col cols="12" md="4" v-if="stock_outs && stock_outs.type == 13 && !isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.ext_order_code") }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_outs.ext_order_code
                        ? stock_outs.ext_order_code
                        : ""
                    }}
                  </v-card>
                </v-col>
                <!-- 出库类型 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="stock_outs && stock_outs.type == 11"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.broken_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!--                    <Required :show="savable" :mode="mode" />-->
                    <v-sheet v-if="savable" width="100%">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('stockOutOrders.Fields.broken_type')"
                        rules="required"
                      >
                        <v-select
                          v-model="stock_outs.broken_type"
                          :items="$consts.stock_out_order.brokenType"
                          single-line
                          dense
                          hide-details
                          :error-messages="errors"
                          class="d-inline mt-0 mb-n1"
                        >
                        </v-select>
                      </ValidationProvider>
                    </v-sheet>
                    <span v-else>{{
                      stock_outs.broken_type | stockOrderOUTBrokenTypeText
                    }}</span>
                  </v-card>
                </v-col>

                <!-- 仓库名称 -->
                <v-col cols="12" :md="isNew ? 4 : 8" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("stockOutOrders.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 实际发生时间 -->
                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                    v-if="isNew && !preview"
                  >
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-model="stock_outs.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                  </v-card>
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile v-else>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_outs.actual_date | formatTime }}</span>
                  </v-card>
                </v-col>

                <!-- 负责人 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.creater")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ accountUser ? accountUser.shop_user_name : "" }}
                  </v-card>
                </v-col>
                <!-- 领料人 -->
                <v-col cols="12" md="4" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("stockOutOrders.Fields.staff")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ accountUser ? accountUser.shop_user_name : "" }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 出库时间 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.finish_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{
                        stock_outs.type == 3
                          ? stock_outs.actual_finish_time
                          : stock_outs.finish_time | formatTime
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 调入门店名称 -->
                <v-col cols="12" md="8" v-if="stock_outs.type == 2">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.in_shop")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="isNew && shopSelected">
                      {{
                        shopSelected.shop_code + " / " + shopSelected.shop_name
                      }}
                    </span>
                    <v-btn
                      v-if="isNew"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="selectShopDialog = true"
                    >
                      <v-icon x-small class="pe-1">fa-store</v-icon>
                      {{ $t("CRUD.chooseInfo", [$consts.shopName()]) }}
                    </v-btn>
                    <span v-else>
                      {{ stock_outs.requisition_shop.shop_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 退货类型 -->
                <v-col cols="12" sm="12" md="12" v-if="stock_outs && stock_outs.type == 13">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text pt-1">
                      {{ $t("stockOutOrders.return.returnType") }}{{ $t("Global.colon") }}
                    </span>
                    <v-radio-group
                      row
                      v-model="returnType"
                      v-if="isNew"
                      class="mt-0"
                      dense
                      hide-details
                    >
                      <v-radio
                        :label="$t('stockOutOrders.return.returnTypeRefundOnly')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('stockOutOrders.return.returnTypeReturnAndRefund')"
                        :key="2"
                        :value="2"
                      />
                    </v-radio-group>
                    <span v-else>
                      {{
                        returnType == 1
                          ? $t('stockOutOrders.return.returnTypeRefundOnly')
                          : returnType == 2
                          ? $t('stockOutOrders.return.returnTypeReturnAndRefund')
                          : returnType == 3
                          ? $t('stockOutOrders.return.returnTypeMixed')
                          : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("stockOutOrders.Fields.attachment")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="savable"
                      v-model="stock_outs.memo"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ stock_outs.memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-card
                    class="pa-2 d-flex overflow-auto text-no-wrap"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("stockOutOrders.Fields.attachments")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 上传图片集 -->
                    <span class="ml-4">
                      <v-card
                        height="160"
                        width="240"
                        v-if="album && album.length > 0"
                      >
                        <v-carousel
                          hide-delimiters
                          cycle
                          height="160"
                          width="240"
                        >
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip right v-if="savable && item">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="imgs_file"
                        v-show="savable"
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :hint="$t('Material.imgsHint')"
                        :rules="imgsRules"
                        v-model="imgs_file"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("ActivityFields.activities") }}
                </v-tab>
                <v-tab
                  @click.stop="
                    tab = 1;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                  v-if="stock_outs.type == 4"
                >
                  {{ $t("stockInOrders.relations") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="stock_out_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat v-if="stock_outs.type == 4">
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="
                            $permission.permissionAllow(item.controller, 'view')
                          "
                          small
                          outlined
                          color="info"
                          class="px-2 me-2"
                          :href="'/#/' + item.identify + '/' + item.id"
                        >
                          <v-icon x-small class="pe-1">fa-align-left</v-icon>
                          {{ $t("Opt.details") }}
                        </v-btn>
                      </template>
                      <template v-slot:item.status="{ item }"
                        ><v-chip
                          v-if="item.controller == 'ProductionPlans'"
                          small
                          label
                          class="ms-4 mt-1"
                          :color="item.status | productionPlansStatusColor"
                          :text-color="
                            item.status | productionPlansStatusTextColor
                          "
                          >{{ item.status | productionPlansStatusText }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="px-4 pb-4">
        <div v-if="!preview">
          <v-data-table
            v-if="isNew && stock_outs.type == 11 && stock_outs.broken_type == 5"
            :headers="foodDetailsHeaders"
            :items="stock_out_food_details"
            :search="filter"
            multi-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('stockOutOrders.DetailNoData')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("stockOutOrders.ObjectName")]) }}
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stock_out_food_details.length
                        ? [
                            1,
                            stock_out_food_details.length,
                            stock_out_food_details.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.order_num="{ item }">
              <NumberInput v-if="isNew" v-model="item.order_num" dense />
              <span v-else>
                {{ item.order_num ? item.order_num : 0 }}
              </span>
            </template>
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-if="savable"
                v-model="item.memo"
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
              >
                <template v-slot:append>
                  <v-icon x-small class="pt-2 pb-1 primary--text">
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
              <span v-else>
                {{ item.memo }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  stock_out_food_details.splice(
                    stock_out_food_details.findIndex((detail) =>
                      item.food_relation_id
                        ? item.food_relation_id == detail.food_relation_id
                        : item.new == detail.new
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-row
                v-if="isNew"
                no-gutters
                align="center"
                class="ps-1 text-no-wrap d-flex"
              >
                <span class="secondary--text">
                  {{
                    $t("CRUD.newInfo", [
                      $t("stockOutOrders.DetailFields.food"),
                    ])
                  }}{{ $t("Global.colon") }}
                </span>
                <SearcherFoodRelations
                  v-model="addFood"
                  :disabledItems="
                    stock_out_food_details
                      ? stock_out_food_details.map((detail) => {
                          return { food_relation_id: detail.food_relation_id };
                        })
                      : []
                  "
                  no-label
                />
              </v-row>
            </template>
          </v-data-table>
          <v-card
            v-else-if="
              stock_outs &&
              stock_outs.stock_order_food_details &&
              stock_outs.stock_order_food_details.length
            "
          >
            <v-tabs v-model="DetailTab" background-color="transparent">
              <v-tab @click.stop="DetailTab = 0">
                <v-card-title>
                  {{
                    $t("CRUD.details", [$t("stockOutOrders.ObjectName")])
                  }}</v-card-title
                >
              </v-tab>
              <v-tab @click.stop="DetailTab = 1">
                <v-card-title>
                  {{
                    $t("stockOutOrders.DetailFields.foodDetails")
                  }}</v-card-title
                >
              </v-tab>
            </v-tabs>
            <v-card-text>
              <v-tabs-items v-model="DetailTab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="detailsHeaders"
                      :items="stockOutDetails"
                      :search="filter"
                      multi-sort
                      class="elevation-2 px-4 mt-4"
                      disable-pagination
                      hide-default-footer
                      :no-data-text="$t('stockOutOrders.DetailNoData')"
                    >
                      <template v-slot:top>
                        <v-toolbar
                          flat
                          class="transparent-background-color"
                          align-self="center"
                        >
                          <span class="caption secondary--text pt-2">
                            {{
                              $t(
                                "$vuetify.dataFooter.pageText",
                                stockOutDetails.length
                                  ? [
                                      1,
                                      stockOutDetails.length,
                                      stockOutDetails.length,
                                    ]
                                  : [0, 0, 0]
                              )
                            }}
                          </span>
                          <v-spacer />
                          <v-row no-gutters class="me-n3">
                            <v-spacer />
                            <v-col cols="12" sm="9" md="8">
                              <v-text-field
                                v-model="filter"
                                clearable
                                hide-details
                                :label="$t('Search.filter')"
                              />
                            </v-col>
                          </v-row>
                        </v-toolbar>
                      </template>
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.material_img="{ item }">
                        <MaterialThumbnail :material="item.material" />
                      </template>
                      <template v-slot:item.Description="{ item }">
                        <span class="text-no-wrap">
                          {{item.material_name, }}
                        </span>
                        <br />
                        <span
                          v-if="item.standard_name"
                          class="caption secondary--text"
                        >
                          {{ $t("Material.Fields.standard")
                          }}{{ $t("Global.colon")
                          }}<span
                            v-if="
                              item.standard_name &&
                              item.standard_name.length > 12
                            "
                            :title="item.standard_name"
                            style="cursor: pointer"
                          >
                            {{ item.standard_name.slice(0, 12) + "......" }}
                          </span>
                          <span v-else>
                            {{ item.standard_name }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.unit="{ item }">
                        <!-- <v-select
              v-if="isNew || item.new"
              :items="item.standard_details"
              v-model="item.standard_detail_id"
              item-text="unit"
              item-value="id"
              noLabel
              single-line
              dense
              hide-details
              style="max-width: 60px"
            ></v-select> -->
                        <span> {{ item.unit }} </span>
                      </template>
                      <template v-slot:item.current_count="{ item }">
                        <span>
                          <span class="text-no-wrap">
                            {{ item.current_count }}
                          </span>
                          <span class="text-no-wrap">
                            {{ item.unit }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.order_num="{ item }">
                        <NumberInput
                          v-if="isNew"
                          v-model="item.order_num"
                          dense
                        />
                        <span v-else>
                          {{ item.order_num ? item.order_num : 0 }}
                        </span>
                      </template>
                      <template v-slot:item.confirm_num="{ item }">
                        <NumberInput
                          v-if="savable && isEdit"
                          v-model="item.confirm_num"
                          dense
                        />
                        <span v-else>
                          <span>
                            {{ item.confirm_num ? item.confirm_num : 0 }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.out_num="{ item }">
                        <NumberInput
                          v-if="savable"
                          v-model="item.out_num"
                          dense
                        />
                        <span v-else>
                          {{ item.out_num ? item.out_num : 0 }}
                        </span>
                      </template>
                      <template v-slot:item.price="{ item }">
                        <v-text-field
                          v-if="isNew"
                          v-model="item.price"
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          :prefix="$t('Global.money')"
                          @blur="
                            item.price =
                              $numberFormatter.formatMoneyFloorWithTwoDot(
                                item.price,
                                2
                              )
                          "
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") }}
                          {{ item.price | formatMoneyFloor }}
                        </span>
                      </template>
                      <template v-slot:item.total="{ item }">
                        <span>
                          {{ $t("Global.money") }}
                          {{ item.total | formatMoneyFloor }}
                        </span>
                      </template>
                      <template v-slot:item.memo="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.memo"
                          single-line
                          dense
                          hide-details
                          class="d-inline mt-0 mb-n1"
                        >
                          <template v-slot:append>
                            <v-icon x-small class="pt-2 pb-1 primary--text">
                              fa-edit
                            </v-icon>
                          </template>
                        </v-text-field>
                        <span v-else>
                          {{ item.memo }}
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="item.new"
                          small
                          text
                          class="danger--text pa-0"
                          @click.stop="
                            stock_out_details.splice(
                              stock_out_details.findIndex((detail) =>
                                item.id
                                  ? item.id == detail.id
                                  : item.new == detail.new
                              ),
                              1
                            )
                          "
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:footer>
                        <v-row
                          v-if="isNew"
                          no-gutters
                          align="center"
                          class="ps-1 text-no-wrap d-flex"
                        >
                          <span class="secondary--text">
                            {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                            }}{{ $t("Global.colon") }}
                          </span>
                          <SearcherStockMaterial
                            v-model="addMaterial"
                            :stockId="stock_outs.stock_id"
                            :disabledItems="
                              stock_out_details
                                ? stock_out_details.map((detail) => {
                                    return { material_id: detail.material_id };
                                  })
                                : []
                            "
                            no-label
                            :stockType="stock_outs.type"
                          />
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="foodDetailsHeaders"
                      :items="stock_out_food_details"
                      :search="filter"
                      multi-sort
                      class="elevation-2 px-4 mt-4"
                      disable-pagination
                      hide-default-footer
                      :no-data-text="$t('stockOutOrders.DetailNoData')"
                    >
                      <template v-slot:top>
                        <v-toolbar
                          flat
                          class="transparent-background-color"
                          align-self="center"
                        >
                          <span class="caption secondary--text pt-2">
                            {{
                              $t(
                                "$vuetify.dataFooter.pageText",
                                stockOutDetails.length
                                  ? [
                                      1,
                                      stockOutDetails.length,
                                      stockOutDetails.length,
                                    ]
                                  : [0, 0, 0]
                              )
                            }}
                          </span>
                          <v-spacer />
                          <v-row no-gutters class="me-n3">
                            <v-spacer />
                            <v-col cols="12" sm="9" md="8">
                              <v-text-field
                                v-model="filter"
                                clearable
                                hide-details
                                :label="$t('Search.filter')"
                              />
                            </v-col>
                          </v-row>
                        </v-toolbar>
                      </template>
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.order_num="{ item }">
                        <NumberInput
                          v-if="isNew"
                          v-model="item.order_num"
                          dense
                        />
                        <span v-else>
                          {{ item.order_num ? item.order_num : 0 }}
                        </span>
                      </template>
                      <template v-slot:item.memo="{ item }">
                        <v-text-field
                          v-if="isNew"
                          v-model="item.memo"
                          single-line
                          dense
                          hide-details
                          class="d-inline mt-0 mb-n1"
                        >
                          <template v-slot:append>
                            <v-icon x-small class="pt-2 pb-1 primary--text">
                              fa-edit
                            </v-icon>
                          </template>
                        </v-text-field>
                        <span v-else>
                          {{ item.memo }}
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="item.new"
                          small
                          text
                          class="danger--text pa-0"
                          @click.stop="
                            stock_out_details.splice(
                              stock_out_details.findIndex((detail) =>
                                item.id
                                  ? item.id == detail.id
                                  : item.new == detail.new
                              ),
                              1
                            )
                          "
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:footer>
                        <v-row
                          v-if="isNew"
                          no-gutters
                          align="center"
                          class="ps-1 text-no-wrap d-flex"
                        >
                          <span class="secondary--text">
                            {{
                              $t("CRUD.newInfo", [
                                $t("stockOutOrders.DetailFields.food"),
                              ])
                            }}{{ $t("Global.colon") }}
                          </span>
                          <SearcherFoodRelations
                            v-model="addFood"
                            :disabledItems="
                              stock_out_food_details
                                ? stock_out_food_details.map((detail) => {
                                    return {
                                      food_relation_id: detail.food_relation_id,
                                    };
                                  })
                                : []
                            "
                            no-label
                          />
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
          <v-data-table
            v-else-if="stock_outs.type != 13"
            :headers="detailsHeaders"
            :items="stockOutDetails"
            :search="filter"
            multi-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('stockOutOrders.DetailNoData')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("stockOutOrders.ObjectName")]) }}
                </v-toolbar-title>
                <v-spacer />
                <!-- 导入商品 -->
                <v-btn
                  color="primary"
                  samll
                  dark
                  class="px-2 me-2 mb-1"
                  v-if="isNew && stock_outs && stock_outs.type"
                  @click="ImportMaterialsDialog = true"
                >
                  {{ $t("Import.import", [$t("Material.ObjectName")]) }}
                </v-btn>
                <!-- 选择商品 -->
                <v-btn
                  color="primary"
                  samll
                  dark
                  class="px-2 me-2 mb-1"
                  v-if="isNew && stock_outs && stock_outs.type"
                  @click="Dialog = true"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
                </v-btn>
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockOutDetails.length
                        ? [1, stockOutDetails.length, stockOutDetails.length]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <!-- 合计 -->
            <template v-slot:body.prepend v-if="!isNew">
              <tr class="d-none d-sm-table-row">
                <td
                  :colspan="
                    stock_outs.status == 2 || isNew ? 6 : 5
                  "
                >
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td class="text-end">
                  <span>{{ getOrderNumTotal() }}</span>
                </td>
                <td
                  v-if="(!isNew && isStockOut) || isView"
                  class="text-end"
                >
                  <span>{{ getOutNumTotal() }}</span>
                </td>
                <td
                  :colspan="isView && stock_outs.status == 3 ? 4 : 2"
                ></td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.material_img="{ item }">
              <MaterialThumbnail :material="item.material" />
            </template>
            <template v-slot:item.Description="{ item }">
              <span class="text-no-wrap">
                {{item.material_name, }}
              </span>
              <br />
              <span v-if="item.standard_name" class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
                }}<span
                  v-if="item.standard_name && item.standard_name.length > 12"
                  :title="item.standard_name"
                  style="cursor: pointer"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </template>
            <template v-slot:item.unit="{ item }">
              <!-- <v-select
              v-if="isNew || item.new"
              :items="item.standard_details"
              v-model="item.standard_detail_id"
              item-text="unit"
              item-value="id"
              noLabel
              single-line
              dense
              hide-details
              style="max-width: 60px"
            ></v-select> -->
              <span> {{ item.unit }} </span>
            </template>
            <template v-slot:item.current_count="{ item }">
              <span>
                <span class="text-no-wrap">
                  {{ item.current_count }}
                </span>
                <span class="text-no-wrap">
                  {{ item.unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.order_num="{ item }">
              <NumberInput v-if="isNew" v-model="item.order_num" dense />
              <span v-else>
                {{ item.order_num ? item.order_num : 0 }}
              </span>
            </template>
            <template v-slot:item.confirm_num="{ item }">
              <NumberInput
                v-if="savable && isEdit"
                v-model="item.confirm_num"
                dense
              />
              <span v-else>
                <span>
                  {{ item.confirm_num ? item.confirm_num : 0 }}
                </span>
              </span>
            </template>
            <template v-slot:item.out_num="{ item }">
              <NumberInput v-if="savable" v-model="item.out_num" dense />
              <span v-else>
                {{ item.out_num ? item.out_num : 0 }}
              </span>
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-if="isNew"
                v-model="item.price"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatMoneyFloorWithTwoDot(
                    item.price,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}
                {{ item.price | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.total="{ item }">
              <span>
                {{ $t("Global.money") }}
                {{ item.total | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-if="savable"
                v-model="item.memo"
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
              >
                <template v-slot:append>
                  <v-icon x-small class="pt-2 pb-1 primary--text">
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
              <span v-else>
                {{ item.memo }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  stock_out_details.splice(
                    stock_out_details.findIndex((detail) =>
                      item.id ? item.id == detail.id : item.new == detail.new
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-row
                v-if="isNew"
                no-gutters
                align="center"
                class="ps-1 text-no-wrap d-flex"
              >
                <span class="secondary--text">
                  {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                  }}{{ $t("Global.colon") }}
                </span>
                <SearcherStockMaterial
                  v-model="addMaterial"
                  :stockId="stock_outs.stock_id"
                  :disabledItems="
                    stock_out_details
                      ? stock_out_details.map((detail) => {
                          return { material_id: detail.material_id };
                        })
                      : []
                  "
                  no-label
                  :stockType="stock_outs.type"
                />
              </v-row>
            </template>
          </v-data-table>
          <!-- 退货出库table -->
          <!-- <ValidationObserver ref="observer" v-else> -->
          <v-data-table
            v-else
            :headers="returnHeaders"
            :items="stockOutDetails"
            :search="filter"
            multi-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('stockOutOrders.DetailNoData')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("stockOutOrders.ObjectName")]) }}
                </v-toolbar-title>
                <v-spacer />
                <!-- 选择验收单 -->
                <!-- <v-btn
                  color="primary"
                  samll
                  dark
                  class="px-2 me-2 mb-1"
                  v-if="isNew"
                  @click="examineReturnDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.chooseInfo", [$t("Examine.ObjectName")]) }}
                </v-btn> -->
                <!-- 选择商品 -->
                <v-btn
                  color="primary"
                  samll
                  dark
                  class="px-2 me-2 mb-1"
                  v-if="isNew"
                  :disabled="returnMaterialsLoading"
                  @click="openMaterialsDialog()"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
                </v-btn>
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockOutDetails.length
                        ? [1, stockOutDetails.length, stockOutDetails.length]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <!-- 退货出库合计 -->
            <template v-slot:body.prepend v-if="!isNew && !savable">
              <tr class="d-none d-sm-table-row">
                <td
                  :colspan="
                    4 +
                    (accountSettings &&
                    accountSettings.product_date_setting == 1
                      ? 2
                      : 0)
                  "
                >
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td class="text-center">
                  <span>{{ getOrderNumTotal() }}</span>
                </td>
                <td class="text-center">
                  <span>{{ getConfirmNumTotal() }}</span>
                </td>
                <td v-if="isView" colspan="2"></td>
                <td></td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.Description="{ item }">
              <span class="text-no-wrap">
                {{item.material_name, }}
              </span>
              <br />
              <span v-if="item.standard_name" class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
                }}<span
                  v-if="item.standard_name && item.standard_name.length > 12"
                  :title="item.standard_name"
                  style="cursor: pointer"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_batch_code="{ item }">
              <span v-if="savable">
                {{ item.stock_batch_code }}
              </span>
              <span v-else>
                {{ item.stock_detail ? item.stock_detail.stock_batch_code : '' }}
              </span>
            </template>
            <template v-slot:item.return_num="{ item }">
              <ValidationProvider
                v-if="savable"
                v-slot="{ errors }"
                :name="$t('stockDetail.Fields.return_num')"
                :rules="getReturnNumRules(item)"
              >
                <NumberInput
                  v-model="item.return_num"
                  dense
                  :error-messages="errors"
                />
              </ValidationProvider>
              <span v-else>
                {{ item.return_num }}
              </span>
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-if="isNew"
                v-model="item.price"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatMoneyFloorWithTwoDot(
                    item.price,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}
                {{ item.price | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.total="{ item }">
              <span>
                {{ $t("Global.money") }}
                {{ getReturnTotal(item) | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-if="savable"
                v-model="item.memo"
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
              >
                <template v-slot:append>
                  <v-icon x-small class="pt-2 pb-1 primary--text">
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
              <span v-else>
                {{ item.memo }}
              </span>
            </template>
            <template v-slot:item.production_date="{ item }">
              <span>{{ item.production_date | formatDate }}</span>
            </template>
            <template v-slot:item.expired_date="{ item }">
              <span>{{ item.expired_date | formatDate }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  stock_out_details.splice(
                    stock_out_details.findIndex((detail) =>
                      item.id ? item.id == detail.id : item.new == detail.new
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- </ValidationObserver> -->
        </div>
        <div v-else class="pb-2">
          <v-card class="px-4">
            <v-card-title>
              {{ $t("CRUD.info", [$t("stockOutOrders.return.detailName")]) }}
            </v-card-title>
            <v-divider />
            <v-card
              v-for="(stock, key) in stockPreview"
              :key="key"
              class="ma-2"
            >
              <v-card-title>
                {{ $t("stockOutOrders.return.title") }}{{ key + 1 }}
              </v-card-title>
              <v-card-subtitle>
                {{ $t("stockDetail.stockInOrderCode") }}{{ $t("Global.colon")
                }}{{ stock.stock_in_order_code }}
              </v-card-subtitle>
              <v-data-table
                :headers="previewHeaders"
                :items="stock.details"
                multi-sort
                disable-pagination
                hide-default-footer
                class="mb-2"
              >
                <template v-slot:item.Description="{ item }">
                  <span class="text-no-wrap">
                    {{item.material_name, }}
                  </span>
                  <br />
                  <span
                    v-if="item.standard_name"
                    class="caption secondary--text"
                  >
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
                    }}<span
                      v-if="
                        item.standard_name && item.standard_name.length > 12
                      "
                      :title="item.standard_name"
                      style="cursor: pointer"
                    >
                      {{ item.standard_name.slice(0, 12) + "......" }}
                    </span>
                    <span v-else>
                      {{ item.standard_name }}
                    </span>
                  </span>
                </template>
              </v-data-table>
            </v-card>
          </v-card>
        </div>
      </div>

      <StockMaterialsSelectsDialog
        v-model="Dialog"
        @confirm="addMaterials = $event"
        :disabledItems="stock_out_details"
        :stockType="stock_outs.type"
      />
      <DialogOrder
        v-model="selectOrderDialog"
        @confirm="selectOrder = $event"
        isActivity
        isReturn
      />
      <ReturnMaterialsSelectsDialog
        v-model="MaterialsDialog"
        :returnMaterials="returnMaterials"
        :choosedItems="stock_out_details"
        @confirm="selectMaterials($event)"
      />

      <ImportMaterialsDialog
        v-model="ImportMaterialsDialog"
        :orderType="stock_outs.type"
        type="stock_out_order"
        :objName="$t('Material.ObjectName')"
        :mode="this.mode"
        @import="
          excelFile = $event;
          importMaterials();
        "
      />
      <DialogShop
        v-model="selectShopDialog"
        :shopLists="shops"
        @confirm="shopSelected = $event"
      />
      <DialogAlert
        v-model="zeroPriceAlert"
        :message="$t('stockOutOrders.Messages.zeroPriceConfirm')"
        useConfirm
        @confirm="zeroPriceConfirmed = true; doSubmit()"
      />
    </ValidationObserver>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import StockOuts from "@/api/stock_out_orders";
import StockOrderOUTActions from "./plugins/Actions";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import { ValidationObserver } from "vee-validate";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import MaterialThumbnail from "@/components/plugins/MaterialThumbnail";
import Shops from "@/api/shops";
import StockOutOrders from "@/api/stock_out_orders";
import { mapState } from "vuex";
import StockMaterialsSelectsDialog from "@/components/plugins/StockMaterialsSelectsDialog";
import ReturnMaterialsSelectsDialog from "./plugins/ReturnMaterialsSelectsDialog";
import DialogOrder from "./plugins/DialogOrder";
import ImportMaterialsDialog from "@/components/plugins/ImportMaterialsDialog";
import Files from "@/api/files";
import consts from "@/consts.js";
import DialogShop from "@/components/plugins/DialogShop";
import DialogAlert from "@/components/plugins/DialogAlert";
import SearcherFoodRelations from "@/components/plugins/SearcherFoodRelations";
import ReturnOrders from "@/api/return_orders";

export default {
  components: {
    Breadcrumbs,
    StockOrderOUTActions,
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
    SearcherStockMaterial,
    NumberInput,
    MaterialThumbnail,
    StockMaterialsSelectsDialog,
    ReturnMaterialsSelectsDialog,
    DialogOrder,
    ImportMaterialsDialog,
    DialogShop,
    DialogAlert,
    SearcherFoodRelations,
  },
  data: () => ({
    productionStockOUTFlg: false,
    tab: null,
    mode: "",
    stock_outs: {},
    stock_out_activities: [],
    panels: [0],
    filter: "",
    stock_out_details: [],
    stock_out_food_details: [],
    addMaterial: null,
    addFood: null,
    addMaterials: [],
    returnMaterials: [],
    //获取可退商品加载中（置灰重选订单/选择商品按钮）
    returnMaterialsLoading: false,
    selectOrderDialog: false,
    selectOrder: null,
    forOrder: null,
    forOrderFlg: false,
    Dialog: false,
    MaterialsDialog: false,
    zeroPriceAlert: false,
    zeroPriceConfirmed: false,
    shopSelected: null,
    stockPreview: [],
    preview: false,
    relations: [],
    excelFile: null,
    ImportMaterialsDialog: false,
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    album: [],
    selectShopDialog: false,
    shops: [],
    DetailTab: null,
    applyData: null,
    returnType: null,
  }),
  mounted() {
    if (this.$route.path.startsWith("/stock-out-orders/new")) {
      this.productionStockOUTFlg = false;
      this.mode = "new";
      if (this.$route.query.examine_code) {
        this.applyData = this.$route.query.examine_code;
        this.$router.push("/stock-out-orders/new");
      } else {
        this.applyData = null;
      }
    } else {
      this.mode = this.$route.params.mode;
      if (this.$route.path.startsWith("/production-stock-out")) {
        this.productionStockOUTFlg = true;
        if (this.mode) {
          this.$router.replace(
            "/production-stock-out/" + this.$route.params.id
          );
        }
      } else if (this.$route.path.startsWith("/stock-out-orders")) {
        this.productionStockOUTFlg = false;
        if (this.mode) {
          this.$router.replace("/stock-out-orders/" + this.$route.params.id);
        }
      }
    }
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" || this.mode == "edit" || this.mode == "out")
      );
    },
    isStockOut() {
      return this.mode == "out";
    },
    isEdit() {
      return this.mode == "edit";
    },
    isNew() {
      return this.mode == "new";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: this.productionStockOUTFlg
            ? "/production-plans"
            : "/current-stocks",
        },
        {
          text: this.productionStockOUTFlg
            ? i18n.t("Nav.productionStockOUT")
            : i18n.t("Nav.stockOutOrders"),
          disabled: false,
          href: this.productionStockOUTFlg
            ? "/production-stock-out"
            : "/stock-out-orders",
        },
        {
          text: this.isNew
            ? i18n.t("Nav.stockOutsNew")
            : i18n.t("Nav.stockOutDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.stock_outs && this.stock_outs.stock_order_code
              ? this.stock_outs.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("stockOutOrders.DetailFields.material_img"),
          align: "start",
          sortable: false,
          value: "material_img",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
      ];
      if (this.stock_outs.status == 2 || this.isNew) {
        headers.push({
          text: i18n.t("stockOutOrders.DetailFields.current_stock_quantity"),
          align: "center",
          value: "current_count",
        });
      }
      headers.push({
        text: i18n.t("stockOutOrders.DetailFields.stock_out_order_num"),
        align: "end",
        value: "order_num",
      });
      if ((!this.isNew && this.isStockOut) || this.isView) {
        headers.push({
          text: i18n.t("stockOutOrders.DetailFields.stock_out_practical_num"),
          align: "end",
          value: "out_num",
        });
      }
      if (this.isView && this.stock_outs.status == 3) {
        headers.push({
          text: i18n.t("stockOutOrders.DetailFields.price"),
          align: "end",
          sortable: false,
          value: "price",
        });
        headers.push({
          text: i18n.t("stockOutOrders.DetailFields.total"),
          align: "end",
          sortable: false,
          value: "total",
        });
      }
      headers.push({
        text: i18n.t("stockOutOrders.DetailFields.memo"),
        align: "end",
        width: "130px",
        sortable: false,
        value: "memo",
      });
      headers.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });

      return headers;
    },
    foodDetailsHeaders() {
      var headers = [
        {
          text: i18n.t("stockOutOrders.DetailFields.food_code"),
          align: "start",
          value: "food_code",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.food_name"),
          align: "start",
          value: "food_name",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.behavior_name"),
          align: "start",
          value: "behavior_name",
        },
      ];
      headers.push({
        text: i18n.t("stockOutOrders.DetailFields.stock_out_order_num"),
        align: "end",
        value: "order_num",
      });
      headers.push({
        text: i18n.t("stockOutOrders.DetailFields.memo"),
        align: "end",
        width: "130px",
        sortable: false,
        value: "memo",
      });
      headers.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });
      return headers;
    },
    returnHeaders() {
      var headers = [
        {
          text: i18n.t("stockOutOrders.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
         {
          text: i18n.t("stockOutOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
      ];
      if (
        this.accountSettings &&
        this.accountSettings.product_date_setting == 1
      ) {
        headers.push(
          {
            text: i18n.t("stockDetail.Fields.production_date"),
            align: "start",
            value: "production_date",
          },
          {
            text: i18n.t("stockDetail.Fields.expired_date"),
            align: "start",
            value: "expired_date",
          }
        );
      }
      if (this.savable) {
        if (this.forOrderFlg) {
          headers.push({
            text: i18n.t("stockDetail.Fields.return_stock_current"),
            align: "center",
            width: "120px",
            value: "stock_current",
          });
        }
        headers.push({
          text: i18n.t("stockDetail.Fields.return_num"),
          align: "center",
          width: "120px",
          value: "return_num",
        });
        //出库单价、小计（选择原订单模式与普通新建模式均显示）
        if (this.forOrderFlg || this.isNew) {
          headers.push(
            {
              text: i18n.t("stockOutOrders.DetailFields.price"),
              align: "center",
              width: "120px",
              sortable: false,
              value: "price",
            },
            {
              text: i18n.t("stockOutOrders.DetailFields.total"),
              align: "center",
              width: "120px",
              sortable: false,
              value: "total",
            }
          );
        }
        headers.push(
          {
            text: i18n.t("stockOutOrders.DetailFields.memo"),
            align: "center",
            width: "130px",
            sortable: false,
            value: "memo",
          },
          {
            text: i18n.t("TableHeaders.actions"),
            align: "center",
            sortable: false,
            value: "actions",
          }
        );
      } else {
        headers.push(
          {
            text: i18n.t("stockOutOrders.DetailFields.stock_out_order_num"),
            align: "center",
            width: "120px",
            value: "order_num",
          },
          {
            text: i18n.t("stockOutOrders.DetailFields.stock_out_confirm_num"),
            align: "center",
            width: "120px",
            value: "confirm_num",
          }
        );
        //出库单价、小计（查看模式始终显示，均不可编辑）
        if (this.isView) {
          headers.push({
            text: i18n.t("stockOutOrders.DetailFields.price"),
            align: "end",
            sortable: false,
            value: "price",
          });
          headers.push({
            text: i18n.t("stockOutOrders.DetailFields.total"),
            align: "end",
            sortable: false,
            value: "total",
          });
        }
        headers.push({
          text: i18n.t("stockOutOrders.DetailFields.memo"),
          align: "center",
          width: "130px",
          sortable: false,
          value: "memo",
        });
      }

      return headers;
    },
    stockOutDetails() {
      return this.stock_out_details.map((detail) => {
        detail.Description = i18n.t(
          "Material.materialNameWithCodeAndStandard",
          [
            detail.material_code,
            detail.material_name,
            detail.standard_name && detail.standard_name.length > 12
              ? detail.standard_name.slice(0, 12) + "......"
              : detail.standard_name,
          ]
        );
        return detail;
      });
    },
    previewHeaders() {
      var headers = [
        {
          text: i18n.t("stockOutOrders.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("stockDetail.Fields.stock_batch_code"),
          align: "start",
          value: "stock_batch_code",
        },
      ];
      if (
        this.accountSettings &&
        this.accountSettings.product_date_setting == 1
      ) {
        headers.push(
          {
            text: i18n.t("stockDetail.Fields.production_date"),
            align: "start",
            value: "production_date",
          },
          {
            text: i18n.t("stockDetail.Fields.expired_date"),
            align: "start",
            value: "expired_date",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("stockDetail.Fields.return_stock_current"),
          align: "center",
          width: "120px",
          value: "stock_current",
        },
        {
          text: i18n.t("stockDetail.Fields.return_num"),
          align: "center",
          width: "120px",
          value: "return_num",
        },
        {
          text: i18n.t("stockOutOrders.DetailFields.memo"),
          align: "center",
          width: "130px",
          sortable: false,
          value: "memo",
        }
      );
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders() {
      var headers = [
        {
          text: i18n.t("ProductionPlans.RelationFields.identify_name"),
          align: "center",
          sortable: false,
          value: "identify_name",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.identify_code"),
          align: "center",
          sortable: false,
          value: "identify_code",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("ProductionPlans.RelationFields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountUser", "accountSettings"]),
  },
  methods: {
    // 合计方法 - savable模式时根据页面数据重新累计
    getOrderNumTotal() {
      if (this.savable) {
        return this.stock_out_details.reduce(
          (sum, item) => sum + (parseFloat(item.order_num) || 0),
          0
        );
      }
      return this.$numberFormatter.formatWithDotNoMoreThan(
        this.stock_outs.order_num_total,
        2
      );
    },
    getConfirmNumTotal() {
      if (this.savable) {
        return this.stock_out_details.reduce(
          (sum, item) => sum + (parseFloat(item.confirm_num) || 0),
          0
        );
      }
      return this.$numberFormatter.formatWithDotNoMoreThan(
        this.stock_outs.confirm_num_total,
        2
      );
    },
    getOutNumTotal() {
      if (this.savable) {
        return this.stock_out_details.reduce(
          (sum, item) => sum + (parseFloat(item.out_num) || 0),
          0
        );
      }
      return this.$numberFormatter.formatWithDotNoMoreThan(
        this.stock_outs.out_num_total,
        2
      );
    },
    //退货出库数量校验规则（仅选择原订单号时限制最大可退数量）
    getReturnNumRules(item) {
      let rules = { required: true };
      if (this.forOrderFlg) {
        //按优先级取有效上限（0 也是有效上限，剩余可退数量为0时不允许再退货）
        let maxNum = [
          item.refundable_num,
          item.stock_current,
          item.current_count,
        ].find((num) => num !== null && num !== undefined && num !== "");
        if (maxNum !== undefined) {
          rules.max_value = maxNum;
        }
      }
      return rules;
    },
    //小计：savable模式按退货数量×单价实时计算
    //查看模式已完成单据使用接口返回的小计，其余按核定数量（未核定时取申请数量）×单价计算
    getReturnTotal(item) {
      if (this.savable) {
        return (
          (parseFloat(item.return_num) || 0) * (parseFloat(item.price) || 0)
        );
      }
      if (this.stock_outs.status == 3 && item.total != null) {
        return item.total;
      }
      return (
        (parseFloat(item.confirm_num) || parseFloat(item.order_num) || 0) *
        (parseFloat(item.price) || 0)
      );
    },
    //选择单据可退商品后整理明细
    selectMaterials(materials) {
      if (materials && materials.length) {
        let newIndex = this.stock_out_details.reduce(
          (max, detail) => Math.max(max, detail.new ? detail.new : 0),
          0
        );
        materials.forEach((material) => {
          newIndex = newIndex + 1;
          this.stock_out_details.push({
            new: newIndex,
            stock_out_id: this.stock_outs.id,
            category_name: material.category_name,
            material_id: material.material_id,
            material_code: material.material_code,
            material_name: material.material_name,
            unit: material.unit,
            price: material.price,
            memo: null,
            standard_name: material.standard_name,
            standard_detail_id: material.standard_detail_id,
            stock_current: material.refundable_num,
            refundable_num: material.refundable_num,
            return_num: material.refundable_num,
            auto_flg: material.auto_flg,
          });
        });
      }
    },
    //打开商品选择对话框（已选择原订单号时从单据可退商品中选择）
    openMaterialsDialog() {
      if (this.forOrderFlg) {
        this.MaterialsDialog = true;
      } else {
        this.Dialog = true;
      }
    },
    getStockOutsFromAPI() {
      var options = {
        order_activity: 1,
      };
      StockOuts.fetchOne(this.$route.params.id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_out;
            this.album = response.data.stock_out.img;
            this.stock_out_activities = response.data.order_activities;
            if (!this.isNew) {
              if (this.stock_outs.type == 13) {
                StockOuts.returnOrderView(this.$route.params.id, options).then(
                  (response) => {
                    this.stock_outs = response.data.stock_out;
                    this.returnType = this.stock_outs.return_type || 2;
                    this.stock_out_details =
                      this.stock_outs && this.stock_outs.stock_order_details
                        ? this.stock_outs.stock_order_details
                        : [];
                  }
                );
              } else {
                this.stock_out_details =
                  this.stock_outs && this.stock_outs.stock_order_details
                    ? this.stock_outs.stock_order_details
                    : [];
                if (this.mode == "out") {
                  this.stock_out_details.forEach((detail) => {
                    detail.out_num = detail.confirm_num;
                  });
                }
              }
            }
            if (this.stock_outs.type == 4) {
              this.relations = [];
              this.relations.push(
                Object.assign(
                  {
                    controller: "ProductionPlans",
                    identify: "production-plans",
                    identify_name: i18n.t("ProductionPlans.ObjectName"),
                    identify_code:
                      response.data.stock_out.production_plan.production_code,
                  },
                  response.data.stock_out.production_plan
                )
              );
            }
            if (
              this.stock_outs.stock_order_food_details &&
              this.stock_outs.stock_order_food_details.length
            ) {
              this.stock_out_food_details =
                this.stock_outs.stock_order_food_details;
            }
          }
        }.bind(this)
      );
    },
    async doSubmit(out_type) {
      //退货出库提交前检测单价为0的数据，弹窗确认后提交
      if (this.isNew && this.stock_outs.type == 13) {
        if (
          !this.zeroPriceConfirmed &&
          this.stock_out_details.some((detail) => !Number(detail.price))
        ) {
          this.zeroPriceAlert = true;
          return;
        }
        this.zeroPriceConfirmed = false; //重置确认标记
      }
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var examine_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.shopFilesUpload(
            this.imgs_file,
            "shop_images"
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => examine_img.push(img.img_name));
          }
        }
      }
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var outDetails = [];
            if (this.mode == "new") {
              var details = [];
              var data = Object.assign({}, this.stock_outs, {
                img: examine_img,
              });
              if (
                this.stock_outs.type == 11 &&
                this.stock_outs.broken_type == 5
              ) {
                this.stock_out_food_details.forEach((detail) => {
                  details.push({
                    food_relation_id: detail.food_relation_id,
                    order_num: detail.order_num,
                    memo: detail.memo,
                  });
                });
                data = Object.assign(data, {
                  stock_order_food_relations: details,
                });
              } else if (this.stock_outs.type == 13) {
                //退货出库：数量取退货出库数量return_num，携带单价提交
                this.stockOutDetails.forEach((detail) => {
                  let detailData = {
                    material_code: detail.material_code,
                    order_num: detail.return_num,
                    price: detail.price,
                    memo: detail.memo,
                    return_type: this.returnType,
                  };
                  if (this.forOrderFlg) {
                    detailData.auto_flg = detail.auto_flg;
                  }
                  details.push(detailData);
                });
                data = Object.assign(data, {
                  stock_order_details: details,
                  return_type: this.returnType,
                });
                //已选择原订单号时关联原单，未选择则不添加order_id字段
                if (this.forOrderFlg) {
                  data = Object.assign(data, {
                    order_id: this.forOrder.id,
                  });
                }
              } else {
                this.stockOutDetails.forEach((detail) => {
                  details.push({
                    material_code: detail.material_code,
                    order_num: detail.order_num,
                    memo: detail.memo,
                  });
                });
                data = Object.assign(data, {
                  stock_order_details: details,
                });
              }

              StockOuts.add(data)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      this.$router.push("/stock-out-orders");
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            if (out_type == "edit") {
              this.submitUploadImg();
              this.stockOutDetails.forEach((detail) => {
                outDetails.push({
                  id: detail.id,
                  confirm_num: detail.confirm_num,
                });
              });
              StockOuts.edit(
                Object.assign(
                  {},
                  { id: this.stock_outs.id },
                  { stock_order_details: outDetails }
                )
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      if (this.productionStockOUTFlg) {
                        this.$router.push("/production-stock-out");
                      } else {
                        this.$router.push("/stock-out-orders");
                      }
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            if (out_type == "out") {
              this.submitUploadImg();
              this.stockOutDetails.forEach((detail) => {
                outDetails.push({
                  id: detail.id,
                  confirm_num: detail.out_num,
                });
              });

              StockOuts.out(
                Object.assign(
                  {},
                  {
                    id: this.stock_outs.id,
                  },
                  {
                    stock_order_details: outDetails,
                  }
                )
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      if (this.productionStockOUTFlg) {
                        this.$router.push("/production-stock-out");
                      } else {
                        this.$router.push("/stock-out-orders");
                      }
                    }
                    // else if (
                    //   response.data.error &&
                    //   response.data.data.length
                    // ) {
                    //   this.errorMaterialInfoAlert = true;
                    //   this.errorMaterialsList = response.data.data;
                    //   if (response.data.error.code == "ERR752") {
                    //     this.errorMsg = i18n.t(
                    //       "stockOutOrders.Messages.some_materials_no_exist"
                    //     );
                    //   } else if (response.data.error.code == "ERR810") {
                    //     this.errorMsg = i18n.t(
                    //       "stockOutOrders.Messages.negative_inventory_out_err"
                    //     );
                    //   }
                    // }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    // //添加预览
    // doPreview() {
    //   if (!this.stock_outs.actual_date) {
    //     this.$snackbar.error(i18n.t("stockOutOrders.Messages.actualDateNull"));
    //   } else if (this.stock_out_details.length < 1) {
    //     this.$snackbar.error(
    //       i18n.t("stockOutOrders.Messages.returnDetailsNull")
    //     );
    //   } else {
    //     if (this.isNew) {
    //       let out_return_details = this.doPreviewData();
    //       if (out_return_details.length == 0) {
    //         this.$snackbar.error(i18n.t("stockOutOrders.Messages.returnEmptyDetails"));
    //         this.$store.dispatch("fullscreenLoadingStop");
    //         return;
    //       }
    //       StockOutOrders.addReturnView({
    //         out_return_details: out_return_details,
    //       }).then(
    //         function (response) {
    //           if (response.data.status.isOK()) {
    //             this.preview = true;
    //             this.stockPreview = response.data.return_stock_orders;
    //           }
    //         }.bind(this)
    //       );
    //     }
    //   }
    // },
    // //整理预览提交数据
    // doPreviewData() {
    //   let details = [];
    //   this.stock_out_details.forEach((detail) => {
    //     if (
    //       detail.return_num > 0 &&
    //       detail.return_num <= detail.stock_current
    //     ) {
    //       details.push({
    //         stock_detail_id: detail.stock_detail_id,
    //         stock_in_order_code: detail.stock_in_order_code,
    //         return_num: detail.return_num,
    //         memo: detail.memo,
    //       });
    //     }
    //   });
    //   return details;
    // },
    // async doReturn() {
    //   this.$store.dispatch("fullscreenLoading");
    //   // 检查一下图片上传的error，拒绝上传
    //   if (this.isNew) {
    //     if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
    //       this.$store.dispatch("fullscreenLoadingStop");
    //       return;
    //     }
    //     //提交图片集
    //     var examine_img = [];
    //     if (this.imgs_file && this.imgs_file.length > 0) {
    //       let response = await Files.shopFilesUpload(
    //         this.imgs_file,
    //         "shop_images"
    //       );

    //       if (response.data.status.isOK()) {
    //         response.data.data.forEach((img) => examine_img.push(img.img_name));
    //       }
    //     }
    //   }
    //   let out_return_details = this.doPreviewData();
    //   if (out_return_details.length == 0) {
    //     this.$snackbar.error(i18n.t("stockOutOrders.Messages.returnEmptyDetails"));
    //     this.$store.dispatch("fullscreenLoadingStop");
    //     return;
    //   }
    //   StockOutOrders.addReturn({
    //     actual_date: this.stock_outs.actual_date,
    //     out_return_details: out_return_details,
    //     img: examine_img,
    //   })
    //     .then(
    //       function (response) {
    //         if (response.data.status.isOK()) {
    //           if (this.productionStockOUTFlg) {
    //             this.$router.push("/production-stock-out");
    //           } else {
    //             this.$router.push("/stock-out-orders");
    //           }
    //         }
    //         this.$store.dispatch("fullscreenLoadingStop");
    //       }.bind(this)
    //     )
    //     .catch(
    //       function () {
    //         this.$store.dispatch("fullscreenLoadingStop");
    //       }.bind(this)
    //     );
    //   // this.$refs.observer.validate().then(
    //   //   function (result) {
    //   //     if (result) {
    //   //
    //   //     } else {
    //   //       this.$store.dispatch("fullscreenLoadingStop");
    //   //     }
    //   //   }.bind(this)
    //   // );
    // },
    checkActions() {
      Shops.checkAction(1).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              this.doSubmit("out");
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
    exportDetail() {
      StockOuts.detailExport(this.stock_outs.id);
    },
    importMaterials() {
      this.$store.dispatch("fullscreenLoading");
      //商品导入
      StockOutOrders.importMaterials(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.ObjectName")])
              );
              this.ImportMaterialsDialog = false;
              let materials = response.data.materials;
              this.stock_out_details = [];
              materials.forEach((material) => {
                this.stock_out_details.push({
                  new: this.stock_out_details.length + 1,
                  stock_out_id: this.stock_outs.id,
                  category_name: material.category_name,
                  material_id: material.material_id,
                  material_code: material.material_code,
                  material_name: material.material_name,
                  unit: material.default_unit,
                  current_count: material.current_count,
                  price: material.supply_price,
                  order_num: material.order_num,
                  memo: material.memo,
                  standard_name: material.standard_name,
                  material: material,
                });
              });
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var stock_out_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.shopFilesUpload(
          this.imgs_file,
          "shop_images"
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => stock_out_img.push(img.img_name));
          StockOuts.update({
            stock_order_code: this.stock_outs.stock_order_code,
            img: stock_out_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
  },
  watch: {
    $route(to) {
      if (to.path.startsWith("/stock-out-orders/new")) {
        this.mode = "new";
        // 重新初始化界面
        this.tab = null;
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        if (this.productionStockOUTFlg) {
          this.$router.replace("/production-stock-out/" + to.params.id);
        } else {
          this.$router.replace("/stock-out-orders/" + to.params.id);
        }
      }
    },
    mode: {
      handler() {
        if (this.isNew) {
          this.returnType = 2;
          this.stock_outs.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
          if (this.applyData != null) {
            this.stock_outs.type = 13;
          }
        } else if (!this.isNew && this.$route.params.id) {
          this.returnType = null;
          this.getStockOutsFromAPI();
        }
      },
    },
    // stock_outs: {
    //   deep: true,
    //   handler() {
    //     if (!this.isNew) {
    //       this.stock_out_details =
    //         this.stock_outs && this.stock_outs.stock_order_details
    //           ? this.stock_outs.stock_order_details
    //           : [];
    //       if (this.mode == "out") {
    //         this.stock_out_details.forEach((detail) => {
    //           detail.out_num = detail.order_num;
    //         });
    //       }
    //     }
    //   },
    // },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          this.stock_out_details.push({
            new: this.stock_out_details.length + 1,
            stock_out_id: this.stock_outs.id,
            category_name: this.addMaterial.category_name,
            material_id: this.addMaterial.material_id,
            material_code: this.addMaterial.material_code,
            material_name: this.addMaterial.material_name,
            unit: this.addMaterial.unit,
            current_count: this.addMaterial.current_count,
            price: this.addMaterial.supply_price,
            memo: null,
            standard_name: this.addMaterial.standard_name,
            material: this.addMaterial,
          });
          this.addMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    addMaterials: {
      handler() {
        this.addMaterials.forEach((addMaterial) => {
          if (addMaterial && addMaterial.id) {
            this.stock_out_details.push({
              new: this.stock_out_details.length + 1,
              stock_out_id: this.stock_outs.id,
              category_name: addMaterial.category_name,
              material_id: addMaterial.material_id,
              material_code: addMaterial.material_code,
              material_name: addMaterial.material_name,
              unit: addMaterial.unit,
              current_count: addMaterial.current_count,
              //出库单价使用最近验收价预填充（仅前端展示，不参与提交）
              price: addMaterial.last_examine_price,
              memo: null,
              standard_name: addMaterial.standard_name,
              material: addMaterial,
            });
          }
        });
      },
    },
    addFood: {
      handler() {
        if (this.addFood && this.addFood.food_relation_id) {
          this.stock_out_food_details.push({
            new: this.stock_out_food_details.length + 1,
            food_relation_id: this.addFood.food_relation_id,
            food_id: this.addFood.food_id,
            food_code: this.addFood.food_code,
            food_name: this.addFood.food_name,
            behavior_name: this.addFood.behavior_name,
            memo: null,
          });
          this.addFood = {
            food_relation_id: 0,
            food_code: "",
            food_name: "",
          }; //消除显示
        }
      },
    },
    shopSelected: {
      handler() {
        this.stock_outs.requisition_shop_id = this.shopSelected
          ? this.shopSelected.shop_id
          : null;
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.stock_outs.img ? this.stock_outs.img : [];
        }
      },
    },
    selectShopDialog: {
      handler() {
        if (this.selectShopDialog) {
          Shops.fetchShops(
            { limit: consts.limitAll, is_initialize: [1] },
            true
          ).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.shops = response.data.shops;
              }
            }.bind(this)
          );
        }
      },
    },
    selectOrder: {
      immediate: true,
      handler() {
        this.stock_out_details = [];
        this.returnMaterials = [];
        if (this.selectOrder) {
          this.forOrder = this.selectOrder;
          this.forOrderFlg = true;
          this.$store.dispatch("fullscreenLoading");
          //获取可退商品期间置灰重选订单/选择商品按钮
          this.returnMaterialsLoading = true;
          ReturnOrders.getReturnableView(this.forOrder.id)
            .then(
              function (response) {
                if (response.data.status.isOK() && this.forOrderFlg) {
                  this.returnMaterials = response.data.returnable_details;
                }
                this.returnMaterialsLoading = false;
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.returnMaterialsLoading = false;
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          this.selectOrderDialog = false;
          this.selectOrder = null;
        }
      },
    },
    forOrderFlg: {
      handler() {
        if (!this.forOrderFlg) {
          this.stock_out_details = [];
          this.returnMaterials = [];
          this.selectOrder = null;
          this.forOrder = null;
        }
      },
    },
  },
};
</script>
